import api from "./api";

class UserService {
    /**************************************
     *  LOCAL STORAGE
     **************************************/

    getLocalUser() {
        const user = JSON.parse(localStorage.getItem("user"));
        return user;
    }

    async updateLocalUser(id) {
        let user = await this.getCurrentUser(id);
        this.removeLocalUser();
        this.setLocalUser(user);
        return user;
    }

    setLocalUser(user) {
        localStorage.setItem("user", JSON.stringify(user));
    }

    removeLocalUser() {
        localStorage.removeItem("user");
    }

    async setCurrentLocalUser() {
        let user = await this.getCurrentUser();
        this.setLocalUser(user);
    }

    async getAllUsers(params) {
        return await api
            .get("/user/list", { params })
            .then((response) => {
                return { status: response.status, data: response.data };
            })
            .catch((error) => {
                return {
                    status: error.response.status,
                    data: error.response.data,
                };
            });
    }

    /**************************************
     *  PARA FILTRAR POR COMUNIDADES
     **************************************/
    async getCommunities() {
        return await api
            .get("/comunidades/list")
            .then((response) => {
                return { status: response.status, data: response.data };
            })
            .catch((error) => {
                return {
                    status: error.response?.status || 500,
                    data: error.response?.data || { message: "Error fetching communities" },
                };
            });
    }

    /**************************************
     *  API FBO
     **************************************/

    async getCurrentUser() {
        return await api
            .get("/user/me")
            .then((response) => {
                if (response.data.UUID) {
                    // Comprobamos si el usuario tiene role=admin
                    if (
                        response.data.role != "superadmin" &&
                        response.data.role != "admin" &&
                        response.data.role != "teamManager" &&
                        response.data.role != "membership"
                    ) {
                        localStorage.clear();
                        throw { data: "Acceso denegado", status: 400 };
                    }
                    // Guardamos la info del usuario en variable local "user"
                    return response.data;
                }
            })
            .catch(function (error) {
                return {
                    status: error.response.status,
                    data: error.response.data,
                };
            });
    }

    async updateUser(pk, data) {
        return await api
            .post("/user/update/" + pk + "/", data)
            .then((response) => {
                return { status: response.status, data: response.data };
            })
            .catch(function (error) {
                return {
                    status: error.response.status,
                    data: error.response.data,
                };
            });
    }

    async updatePassword(pk, data) {
        return await api
            .put("/password/update/" + pk + "/", data)
            .then((response) => {
                return { status: response.status, data: response.data };
            })
            .catch(function (error) {
                return {
                    status: error.response.status,
                    data: error.response.data,
                };
            });
    }

    async export_users_list() {
        return api
            .get("/user/export_users", {
                responseType: "blob",
            })
            .then((response) => {
                var date = new Date();
                let currentDate = date.getFullYear() + "-" + date.getMonth()+1 + "-" + date.getDate();
                let filename = `${currentDate}-user_data`;
                const url = window.URL.createObjectURL(
                    new Blob([response.data], { type: "application/xlsx" })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                console.log('This is the response ', response.data);
                return { status: response.status, data: link.href };
            })
            .catch(function (error) {
                return {
                    status: error.response.status,
                    data: error.response.data,
                };
            });
    }
}

export default new UserService();
